import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const r2b_referral_12: R2BReferralBrandEntity = {
  token: "r2b_referral_12",
  type: "r2bReferralBrand",
  name: "Cedar & Sage",
  email: "james.reed@example.com",
  website: "cedarandsage.org",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
